(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nolya-steps-pro"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('wb-steps-pro')){
  customElements.define('wb-steps-pro',class extends HTMLElement{
    connectedCallback(){
      if(this.dataset.progress!=='true')return;
      this.items=[...this.querySelectorAll('.wbsp__step')];
      this.update=()=>{if(this.frame)return;this.frame=requestAnimationFrame(()=>{this.frame=0;let active=this.items[0];for(const item of this.items)if(item.getBoundingClientRect().top<=innerHeight*.6)active=item;this.items.forEach(item=>item.classList.toggle('is-current',item===active));});};
      this.observer=new IntersectionObserver(entries=>{if(entries[0].isIntersecting){window.addEventListener('scroll',this.update,{passive:true});this.update();}else{window.removeEventListener('scroll',this.update);}});
      this.observer.observe(this);
    }
    disconnectedCallback(){this.observer?.disconnect();if(this.update)window.removeEventListener('scroll',this.update);cancelAnimationFrame(this.frame);}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-count-stats"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scroll-count-stats')) {
    customElements.define('scroll-count-stats', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => { if (this.isConnected) this.setup(); });
      }

      disconnectedCallback() {
        this.cleanup();
      }

      cleanup() {
        this.observer?.disconnect();
        this.items?.forEach((item) => cancelAnimationFrame(item.frame));
        if (this.motion && this.onMotion) this.motion.removeEventListener('change', this.onMotion);
        if (this.onSelect) document.removeEventListener('shopify:block:select', this.onSelect);
      }

      setup() {
        this.cleanup();
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.duration = Math.max(300, Math.min(5000, Number(this.dataset.duration) || 1800));
        this.repeat = this.dataset.repeat === 'true';
        this.items = Array.from(this.querySelectorAll('[data-stat]')).map((element) => {
          const raw = (element.dataset.target || '').trim();
          const target = Number(raw);
          const valid = /^\d+(?:\.\d{1,3})?$/.test(raw) && Number.isFinite(target) && target <= 999999999999;
          const digits = element.querySelector('[data-digits]');
          if (!valid || !digits) return null;
          const decimals = (raw.split('.')[1] || '').length;
          const formatter = new Intl.NumberFormat('en-US', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals,
            useGrouping: this.dataset.grouping !== 'none'
          });
          const format = (value) => {
            const formatted = formatter.format(value);
            return this.dataset.grouping === 'space' ? formatted.replace(/,/g, '\u202f') : formatted;
          };
          element.querySelector('[data-sizer]').textContent = format(target);
          const affixes = element.querySelectorAll('.scs__affix');
          element.querySelector('[data-accessible]').textContent = affixes[0].textContent + format(target) + affixes[1].textContent;
          return { element, target, digits, decimals, format, frame: 0, started: false };
        }).filter(Boolean);
        this.items.forEach((item) => { item.digits.textContent = item.format(item.target); });
        this.onMotion = () => this.setup();
        this.motion.addEventListener('change', this.onMotion);
        this.onSelect = (event) => {
          this.items.forEach((item) => {
            if (item.element === event.target || item.element.contains(event.target)) {
              this.finish(item);
              if (!this.repeat) this.observer?.unobserve(item.element);
            }
          });
        };
        document.addEventListener('shopify:block:select', this.onSelect);
        if (this.dataset.animate !== 'true' || this.motion.matches || !('IntersectionObserver' in window)) return;
        const byElement = new Map(this.items.map((item) => [item.element, item]));
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const item = byElement.get(entry.target);
            if (entry.isIntersecting && entry.intersectionRatio >= 0.15 && !item.started) {
              this.animate(item);
              if (!this.repeat) this.observer.unobserve(entry.target);
            } else if (!entry.isIntersecting && this.repeat) {
              cancelAnimationFrame(item.frame);
              item.started = false;
              item.digits.textContent = item.format(0);
            }
          });
        }, { threshold: [0, 0.15] });
        this.items.forEach((item) => {
          item.digits.textContent = item.format(0);
          this.observer.observe(item.element);
        });
      }

      finish(item) {
        cancelAnimationFrame(item.frame);
        item.started = true;
        item.digits.textContent = item.format(item.target);
      }

      animate(item) {
        item.started = true;
        let start;
        const step = (time) => {
          if (!this.isConnected) return;
          if (start === undefined) start = time;
          const progress = Math.min((time - start) / this.duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          const factor = Math.pow(10, item.decimals);
          const value = Math.floor(item.target * eased * factor) / factor;
          item.digits.textContent = item.format(progress === 1 ? item.target : value);
          if (progress < 1) item.frame = requestAnimationFrame(step);
        };
        item.frame = requestAnimationFrame(step);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
